import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>Our New Home and Residential Sales services:</h2>
          <h5 className={classes.description}>
            Kinos’s partnership culture, our commitment to excellence and uncompromising integrity makes us an excellent choice for investors with a long-term vision.
          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
We also custom tailor your investment strategies to clients’ specific needs.
</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="Project sales and marketing"
            description={
              <span>
                <p>
                  Investment valuations of both existing and acquirable assets.
                  Market research and underwriting/due diligence support
                  As your partners, our priority is to add value to your project, brand it, position it, market it and successfully sell it out beyond expectations.

                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="Pricing appraisals"
            description={
              <span>
                <p>
                  Data, Research & Pricing.
                  Pricing and positioning your property in the marketplace is essential. Using proprietary, historical, and public data, we compile and consolidate analysis to guide competitive and strategic pricing or your property.
                  Throughout the process, we will continue to provide you with ongoing feasibility studies and up-to-the-minute market research including pricing, demographics and cultural trends.


                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="Lettings advice"
            description={
              <span>
                <p>
                  Strategizing Every Step
                  Every stage of the development lifecycle is meticulously planned and executed, abiding by market trends and forecasts to produce results. The groups within our team are highly specialized in each area, and work collaboratively to seamlessly transition between stages, striving for efficiency and distinguishing market solutions.

                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>









      </GridContainer>
    </div>
  );
}

export default withStyles(servicesStyle)(SectionServices);
